import { NIL as NIL_UUID } from "uuid";

export const FormNames = Object.freeze({
  TaskDetailsForm: "Detail Fields",
  TaskCommentsForm: "Comment Fields",
});

export const sectionList = [
  `1:${FormNames.TaskDetailsForm}`,
  `2:${FormNames.TaskCommentsForm}`,
];

const formKeys = Object.keys(FormNames);

export const AddFieldToLayoutSectionUtil = (allTaskLayout, formName, field) => {
  let newTaskLayout;
  if (!allTaskLayout) {
    newTaskLayout = {
      TaskDetailsForm: {
        Id: NIL_UUID,
        Fields: [],
      },
      TaskCommentsForm: {
        Id: NIL_UUID,
        Fields: [],
      },
    };
  } else {
    newTaskLayout = JSON.parse(JSON.stringify(allTaskLayout));
  }

  let formNode =
    formName === FormNames.TaskDetailsForm ? formKeys[0] : formKeys[1];
  const newTaskLayoutForm = newTaskLayout[formNode];

  const newField = JSON.parse(JSON.stringify(field));
  let newFieldDisplayOrder =
    newTaskLayoutForm.Fields.length === 0
      ? 1
      : newTaskLayoutForm.Fields[newTaskLayoutForm.Fields.length - 1]
          .DisplayOrder + 1;

  newTaskLayoutForm.Fields.push({
    ...newField,
    LocalLabel: newField.Label,
    IsRequired: newField.Required,
    IsDisabled: false,
    LookupValues: "",
    DynamicFieldId: newField.Id,
    DisplayOrder: newFieldDisplayOrder,
    Id: NIL_UUID,
  });

  return newTaskLayout;
};

export const ModifyLayoutFromFieldUtil = (allTaskLayout, formName, field) => {
  const newTaskLayout = JSON.parse(JSON.stringify(allTaskLayout));
  let formNode =
    formName === FormNames.TaskDetailsForm ? formKeys[0] : formKeys[1];
  const newTaskLayoutForm = newTaskLayout[formNode];
  let newFormField = newTaskLayoutForm.Fields.find(
    (f) => f.DisplayOrder === field.DisplayOrder
  );

  newFormField.LocalLabel = field.LocalLabel;
  newFormField.IsRequired = field.IsRequired;
  newFormField.IsDisabled = field.IsDisabled;

  return newTaskLayout;
};

export const DeleteLayoutFormFieldUtil = (allTaskLayout, formName, field) => {
  const newTaskLayout = JSON.parse(JSON.stringify(allTaskLayout));
  let formNode =
    formName === FormNames.TaskDetailsForm ? formKeys[0] : formKeys[1];
  const newTaskLayoutForm = newTaskLayout[formNode];
  let newFormField = newTaskLayoutForm.Fields.find(
    (f) => f.DisplayOrder === field.DisplayOrder
  );
  newTaskLayoutForm.Fields = newTaskLayoutForm.Fields.filter(
    (f) => f.DisplayOrder !== field.DisplayOrder
  );
  let newFieldId = newFormField.Id;

  return { newTaskLayout, newFieldId };
};
